import React from "react";
import { Box, Flex, Input, InputGroup, InputLeftElement } from "@chakra-ui/react";
import { FaSearch } from "react-icons/fa";

/**
 * FilterBar — the filter row: a flex container for a search field plus selects.
 * Designed to drop into <Panel filters={...} />, but works standalone too.
 * Template ref: `.filters` (search flexes, selects sit to the right).
 */
const FilterBar = ({ children, ...rest }) => (
  <Flex align="center" gap="8px" flexWrap="wrap" w="100%" {...rest}>
    {children}
  </Flex>
);

/**
 * FilterSearch — the flex-growing search input used as the first FilterBar child.
 * Template ref: `.search input` (31px tall). Spreads onto the underlying Input.
 */
export const FilterSearch = ({ icon, containerProps, ...inputProps }) => (
  <Box flex="1" minW="180px" {...containerProps}>
    <InputGroup>
      <InputLeftElement h="31px" pointerEvents="none" color="portal.muted">
        {icon || <FaSearch size="0.8em" />}
      </InputLeftElement>
      <Input h="31px" fontWeight="600" {...inputProps} />
    </InputGroup>
  </Box>
);

export default FilterBar;
